import { render, staticRenderFns } from "./UploadCases.vue?vue&type=template&id=896f41b0&scoped=true"
import script from "./UploadCases.vue?vue&type=script&lang=js"
export * from "./UploadCases.vue?vue&type=script&lang=js"
import style0 from "./UploadCases.vue?vue&type=style&index=0&id=896f41b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896f41b0",
  null
  
)

export default component.exports